import React, { useState, useEffect } from "react";
import { Typography, Button, Box } from "@mui/material";
import { DataGridPro } from '@mui/x-data-grid-pro';
import ReportToolbar from "../ReportToolbar";
import ReportFooter from "../ReportFooter";
import axios from "axios";
import { APIURL } from "../../../config";

export default function ClaimBalanceReport(props) {
    const columns = [
        {
            field: "claim_ID",
            headerName: "Claim ID",
            width: 100,
        },
        {
            field: "PatientName",
            headerName: "Patient Name",
            width: 150,
        },
        {
            field: "PlanName",
            headerName: "Plan Name",
            width: 125,
        },
        {
            field: "Service_Date",
            headerName: "Service Date",
            width: 100,
        },
        {
            field: "Outstanding_Balance",
            headerName: "Outstanding Balance",
            width: 100,
        },
        {
            field: "ClaimStatus",
            headerName: "Status",
            width: 100,
        },
    ];

    const rows = props.data.outstanding.map((claim, index) => {
        const claimDets = {
            id: index,
            claim_ID: claim.Claim_ID,
            PatientName: claim.Patient_Name,
            PlanName: claim.Plan_Name,
            Service_Date: claim.Service_Date,
            ClaimStatus: claim.Status,
            Outstanding_Balance: claim.Balance,
        };
        return claimDets;
    });

    const totalRow = {
        id: 'total-row',
        claim_ID: '',
        PatientName: '',
        Plan_Name: '',
        Service_Date: 'TOTAL:',
        Outstanding_Balance: props.data.balTotal,
        ClaimStatus: '',
        isTotal: true,
    };

    const CustomToolbar = () => {
        const balance = props.data.balance || [];

        return (
            <ReportToolbar companyName={props.user.company_name} reportTitle="Claim Balance Report">
                <Box sx={{ pl: 1, pr: 1 }}>
                    <div style={{ fontSize: '16px', fontWeight: 'bold' }}>Carrier Name: Medicaid</div>
                    <div style={{ fontSize: '16px', fontWeight: 'bold' }}>Cutoff Date: {props.data.cutoff}</div>
                </Box>
                <Box>
                    <table style={{ width: '100%', marginTop: '16px', background: 'white', borderRadius: 8 }}>
                        <thead>
                            <tr style={{ background: '#ffffff', border: '2px solid black' }}>
                                <th style={{ textAlign: 'left', padding: '8px' }}>Carrier Name</th>
                                <th style={{ textAlign: 'right', padding: '8px' }}>Total</th>
                                <th style={{ textAlign: 'right', padding: '8px' }}>Current</th>
                                <th style={{ textAlign: 'right', padding: '8px' }}>30 days</th>
                                <th style={{ textAlign: 'right', padding: '8px' }}>60 days</th>
                                <th style={{ textAlign: 'right', padding: '8px' }}>90 days</th>
                                <th style={{ textAlign: 'right', padding: '8px' }}>120 days</th>
                                <th style={{ textAlign: 'right', padding: '8px' }}>150+ days</th>
                            </tr>
                        </thead>
                        <tbody>
                            {balance.map((row, idx) => (
                                <tr key={idx}>
                                    <td style={{ textAlign: 'left', padding: '8px' }}>{row.carrier}</td>
                                    <td style={{ textAlign: 'right', padding: '8px' }}>{row.total}</td>
                                    <td style={{ textAlign: 'right', padding: '8px' }}>{row.current}</td>
                                    <td style={{ textAlign: 'right', padding: '8px' }}>{row._30}</td>
                                    <td style={{ textAlign: 'right', padding: '8px' }}>{row._60}</td>
                                    <td style={{ textAlign: 'right', padding: '8px' }}>{row._90}</td>
                                    <td style={{ textAlign: 'right', padding: '8px' }}>{row._120}</td>
                                    <td style={{ textAlign: 'right', padding: '8px' }}>{row._150}</td>
                                </tr>
                            ))}
                            <tr style={{ background: '#e3e3e3', fontWeight: 'bold' }}>
                                <td style={{ textAlign: 'left', padding: '8px' }}></td>
                                <td style={{ textAlign: 'right', padding: '8px' }}>Total</td>
                                <td style={{ textAlign: 'right', padding: '8px' }}>{props.data.currTotal}</td>
                                <td style={{ textAlign: 'right', padding: '8px' }}>{props.data._30Total}</td>
                                <td style={{ textAlign: 'right', padding: '8px' }}>{props.data._60Total}</td>
                                <td style={{ textAlign: 'right', padding: '8px' }}>{props.data._90Total}</td>
                                <td style={{ textAlign: 'right', padding: '8px' }}>{props.data._120Total}</td>
                                <td style={{ textAlign: 'right', padding: '8px' }}>{props.data._150Total}</td>
                            </tr>
                        </tbody>
                    </table>
                </Box>
            </ReportToolbar>
        );
    };

    return (
        <div style={{ width: '100%' }}>
            <div style={{ height: '80vh' }}>
                <DataGridPro
                    initialState={{ sorting: { sortModel: [{ field: "Service_Date", sort: "desc" }] } }}
                    getRowId={(row) => row.id}
                    rows={rows}
                    columns={columns}
                    slots={{
                        toolbar: CustomToolbar,
                        footer: ReportFooter
                    }}
                    pinnedRows={{ bottom: [totalRow] }}
                    getRowClassName={(params) => {
                        return params.row.isTotal ? 'total-row' : '';
                    }}
                    sx={{
                        '& .total-row': {
                            backgroundColor: '#f5f5f5',
                            fontWeight: 'bold',
                            borderTop: '2px solid #ddd',
                            '&:hover': {
                                backgroundColor: '#f0f0f0',
                            }
                        }
                    }}
                    checkboxSelection={false}
                    disableRowSelectionOnClick
                    disableVirtualization
                    showToolbar
                />
            </div>
        </div>
    );
}